const routerArr = [{
        path: 'enterprise',
        component: (resolve) => require(["@/container/pages/enterpriseManagement/index"], resolve),
        meta: {
            show: '1110',
            title: '单位管理',
            source: '11b7',
            keepAlive:true,
            keepPath:"/home/enterprise"
        }
    },
    {
        path: 'enterprise/:id',
        name: 'enterpriseDetail',
        component: (resolve) => require(["page/enterpriseManagement/detail"], resolve),
        meta: {
            show: '1110',
            title: '详情',
            keepPath:"/home/enterprise"
        }
    },
    {
        path: 'enterpriseAdd',
        name: 'enterpriseAdd',
        // component: (resolve) => require(["page/enterpriseManagement/addPage"], resolve),
        component: (resolve) => require(["page/enterpriseManagement/add"], resolve),
        meta: { show: '1110', title: '新增', keepPath:"/home/enterprise" }
    },
    {
        path: 'community',
        name: 'community',
        component: (resolve) => require(["page/enterpriseManagement/community"], resolve),
        meta: { show: '1110', title: '社区管理', keepPath:"/home/enterprise"}
    },
    {
        path: 'communityDetail',
        name: 'communityDetail',
        component: (resolve) => require(["page/enterpriseManagement/communityDetail"], resolve),
        meta: { show: '1110', title: '社区详情' , keepPath:"/home/enterprise"}
    },
    {
        path: 'account',
        name: 'account',
        component: (resolve) => require(["page/enterpriseManagement/account"], resolve),
        meta: { show: '1110', title: '账户管理' , keepPath:"/home/enterprise"}
    },
    {
        path: '/accountAdd',
        name: 'accountAdd',
        component: (resolve) => require(["page/enterpriseManagement/accountAdd"], resolve),
        meta: { show: '1110', title: '新增账户', keepPath:"/home/enterprise" }
    },
    {
        path: 'account/:id',
        name: 'accountDetail',
        component: (resolve) => require(["page/enterpriseManagement/accountDetail"], resolve),
        meta: { show: '1110', title: '详情' }
    },
    {
        path: 'enterpriseFunc',
        name: 'enterpriseFunc',
        component: (resolve) => require(["page/enterpriseManagement/allocationFunction"], resolve),
        meta: { show: '1110', title: '分配功能', source: '11b6', keepPath:"/home/enterprise" }
    },
    {
        path: 'wappushmanager',
        name: 'wappushmanager',
        component: (resolve) => require(["page/enterpriseManagement/property"], resolve),
        meta: {  show: '1110', title: '推送设置', keepPath:"/home/enterprise"}
    },
    {
        path: 'aduitPage',
        name: 'aduitPage',
        component: (resolve) => require(["page/enterpriseManagement/aduitPage/index.vue"], resolve),
        meta: {  show: '1110', title: '单位认证',keepPath:"/home/enterprise" }
    },
    {
        path: 'aduitDetail',
        name: 'aduitDetail',
        component: (resolve) => require(["page/enterpriseManagement/aduitPage/detail.vue"], resolve),
        meta: {  show: '1110', title: '单位认证详情', keepPath:"/home/enterprise"}
    },
];

export default routerArr;



// WEBPACK FOOTER //
// ./src/container/pages/enterpriseManagement/_res.js